/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateUnit} from '../api'

export const useMutationUpdateUnit = createReactQueryMutationHook('updateUnit', updateUnit)
